import { createSlice } from '@reduxjs/toolkit'
import { AppDispatch, AppThunk } from '../store'
import getModernDictionary from '../../lib/api/dictionary/getModernDictionary'
import getModernFilterMenu from '../../lib/api/dictionary/getModernFilterMenu'

export const MenuType:string[] = [
  'RESION',
  'TOPIC',
  'SHARP',
]

type Menu = {
  count: number
  data: any[]
}

type Menus = {
  [propName: string]: Menu
}

type ModernState = {
  isLoading: boolean
  isError: boolean
  errorMessage: string
  isInit: boolean
  result: any[]
  photoDict: []
  totalCount: number
  filterMenu: Menus
  filterState: any
}

const initialState: ModernState = {
  isLoading: false,
  isError: false,
  errorMessage: '',
  isInit: false, // -1이 전체임. 헷갈림 주의
  result: [],
  photoDict: [],
  totalCount: 0,
  filterMenu: {
    RESION: {
      count: 0,
      data: [],
    },
    TOPIC: {
      count: 0,
      data: [],
    },
    SHARP: {
      count: 0,
      data: [],
    },
  },
  filterState: {
    SEARCHAREA: '', 
    SEARCHFROM: '0',
    SEARCHSHARP: '',
    SEARCHTOPIC: '',
    SEARCHTRANSYN: 'N',
    SEARCHTYPE: 'resion',
  }
}

const modernSlice = createSlice({
  name: 'modern',
  initialState,
  reducers: {
    getModernStart: (state) => {
      // 요청 시작
      state.isLoading = true
    },
    getModernEnd: (state) => {
      // 요청 끝
      state.isLoading = false
    },
    getModernError: (state, action) => {
      // 에러 발생
      state.isError = true
      state.isLoading = false
      state.errorMessage = action.payload
    },
    setIsInit: (state, action) => {
      state.isInit = action.payload
    },
    setContents: (state, action) => {
      // 데이터 저장
      state.result = action.payload
    },
    setMoreContent: (state, action) => {
      // 데이터 저장
      state.result = state.result.concat(action.payload)
    },
    setModernPhoto: (state, action) => {
      state.photoDict = action.payload
    },
    setTotalCount: (state, action) => {
      // 데이터 저장
      state.totalCount = action.payload
    },
    setFilterMenu: (state, action) => {
      // 필터 메뉴 저장
      state.filterMenu = action.payload
    },
    setFilterState: (state, action) => {
      // 필터, 소팅 상태 저장
      state.filterState = action.payload
    }
  },
})

// 역사탐방정보 필터메뉴

// 역사탐방정보 리스트
export const fetchModernDictionary =
  (filterState: ModernState['filterState'], isMore: boolean): AppThunk =>
    //@ts-ignore
    async (dispatch: AppDispatch) => {
      try {
        if (!isMore) dispatch(getModernStart())

        const result = await getModernDictionary(filterState)
        if (result.result?.map?.status === 'BAD_GATEWAY') throw new Error('BAD_GATEWAY')
        dispatch(setFilterState(filterState))
        if (isMore) {
          dispatch(setMoreContent(result.result?.map?.RESP_RESULT?.map?.MODERN_LIST?.myArrayList))
        } else {
          dispatch(setContents(result.result?.map?.RESP_RESULT?.map?.MODERN_LIST?.myArrayList))
          dispatch(setTotalCount(result.result?.map?.RESP_RESULT?.map?.TOTAL_CNT))
        }
        
        if (!isMore) dispatch(getModernEnd())
      } catch (e: any) {
        console.log(e)
        dispatch(getModernError(e.message))
      }
    }

export const settingFilterMenu = (): AppThunk => 
    //@ts-ignore
    async (dispatch: AppDispatch) => {
    let menu: Menus = {
      RESION: {
        count: 0,
        data: [],
      },
      TOPIC: {
        count: 0,
        data: [],
      },
      SHARP: {
        count: 0,
        data: [],
      },
    }

    const result = await getModernFilterMenu();
    for (let item of result?.result.map?.RESP_RESULT.myArrayList) {
      item = {
        ...item.map,
        SELECTED: false
      }
      if (item.GUBUN === 'TOPIC') {
        menu['TOPIC'].count += 1;
        menu['TOPIC'].data.push(item)
      } else if (item.GUBUN === 'RESION') {
        menu['RESION'].count += 1;
        menu['RESION'].data.push(item)
      } else {
        menu['SHARP'].count += 1;
        menu['SHARP'].data.push(item)
      }
    }
    dispatch(setFilterMenu(menu))
  }


export const {
  getModernStart,
  getModernEnd,
  getModernError,
  setIsInit,
  setContents,
  setMoreContent,
  setModernPhoto,
  setTotalCount,
  setFilterMenu,
  setFilterState,
} = modernSlice.actions

export default modernSlice.reducer
